export const migipediaDarkTheme = {
  name: 'Migipedia Dark Theme',
  themeId: 'migipediaDark',
  colors: {
    brand: {
      primary: {
        10: 'rgba(var(--msrc-migipedia-primary-color, 0, 0, 0), 0.1 )',
        20: 'rgba(var(--msrc-migipedia-primary-color, 0, 0, 0), 0.2 )',
        30: 'rgba(var(--msrc-migipedia-primary-color, 0, 0, 0), 0.3 )',
        40: 'rgba(var(--msrc-migipedia-primary-color, 0, 0, 0), 0.4 )',
        50: 'rgba(var(--msrc-migipedia-primary-color, 0, 0, 0), 0.5 )',
        60: 'rgba(var(--msrc-migipedia-primary-color, 0, 0, 0), 0.6 )',
        70: 'rgba(var(--msrc-migipedia-primary-color, 0, 0, 0), 0.7 )',
        80: 'rgba(var(--msrc-migipedia-primary-color, 0, 0, 0), 0.8 )',
        90: 'rgba(var(--msrc-migipedia-primary-color, 0, 0, 0), 0.9 )',
        100: 'rgba(var(--msrc-migipedia-primary-color, 0, 0, 0), 1 )'
      },
      secondary: {
        100: '#FF8533'
      },
      accent: {
        100: '#FF6600'
      },
      text: {
        100: '#FFFFFF'
      },
      textInverted: {
        100: '#000000'
      },
      negative: {
        50: '#FEE1DC',
        100: '#EE0000'
      },
      positive: {
        100: '#468C00'
      },
      highlight: {
        100: '#7CCEF7'
      },
      altHighlight: {
        100: '#17A1E6'
      },
      backgroundHighlight: {
        100: '#EEF8FE'
      },
      alternative: {
        100: '#FF8533'
      }
    },
    tints: {
      gray: {
        10: '#52525B',
        25: '#71717A',
        30: '#71717A',
        40: '#A1A1AA',
        50: '#A1A1AA',
        60: '#D4D4D8',
        75: '#D4D4D8',
        80: '#E4E4E7',
        90: '#E4E4E7',
        100: '#F4F4F5'
      },
      white: {
        100: '#3F3F46'
      },
      black: {
        85: '#F4F4F5',
        90: '#FFFFFF'
      }
    }
  },
  backgrounds: {
    tile: '#F4F4F5'
  },
  fonts: {
    families: {
      text: '"var(--font-helvetica-now-display)", Helvetica, Arial, sans-serif',
      condensed: '"var(--font-helvetica-now-display)", Helvetica, Arial, sans-serif',
      heading: '"var(--font-helvetica-now-display)", Helvetica, Arial, sans-serif'
    },
    sizes: {
      text: {
        tiny: '10px',
        xsmall: '12px',
        small: '14px',
        medium: '16px',
        large: '18px',
        xlarge: '24px',
        huge: '32px'
      }
    },
    weights: {
      thin: 100,
      light: 200,
      regular: 400,
      semiBold: 500,
      bold: 700
    }
  },
  borderRadiuses: {
    xsmall: '6px',
    small: '10px',
    medium: '16px',
    large: '9999px'
  }
};